import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

class CustomTrainerCommentsModel {
    value: string;
    output: string;
}

@Component({
    selector: 'app-journey-list-template-trainer-comments',
    templateUrl: './list-template-trainer-comments.component.html',
    styleUrls: ['./list-template-trainer-comments.component.scss']
})
export class LearningJourneyListTemplateTrainerCommentsComponent implements OnInit {

    details: CustomTrainerCommentsModel = null;
    title: string = null;
    description: string = null;

    @Input('data') set setDetails(data) {
        if (!!data) {
            this.details = data.details.trainer_comments;
            this.title = data.title;
            this.description = data.text;
        }
    }

    constructor() {
    }

    ngOnInit() {
    }


}
